// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.link-pdf[data-v-7a4e7832] {\n  display: inline-block;\n  line-height: 1.8rem;\n  width: 150px;\n  border: 0px solid red;\n  margin-right: 0.8rem;\n}\n.link-pdf a[data-v-7a4e7832] {\n  vertical-align: middle;\n  padding-right: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
